import { getNetworkDownloadSpeed } from "./NetworkSpeedTestHelper";
import { Row, Col, Progress } from "reactstrap";
import React, { useState, useEffect } from "react";
import { exerciseType } from "../../components/constants/constants";
import { includes } from "lodash";

export const NetWorkSpeedTest = ({ requirementdata, arr }) => {
  const [downloadingSpeed, SetDownloadingSpeed] = useState();
  let percentage = 0;
  let pClass = "danger";
  useEffect(() => {
    if (!downloadingSpeed) {
      getNetworkDownloadSpeed(SetDownloadingSpeed);
    }
  }, [downloadingSpeed]);

  const resetSpeed = () => {
    SetDownloadingSpeed(null);
  };
  if (downloadingSpeed) {
    percentage = (downloadingSpeed?.mbps / 3) * 100;
  }

  if (percentage >= 50 && percentage < 80) {
    pClass = "warning";
  } else if (percentage >= 80) {
    pClass = "success";
  }

  return (
    <Row className="p-4 py-2 f-13">
          { requirementdata && requirementdata === "system requirement" ? (
              <>
                <Col md={4} className="sfw-700">Internet speed:</Col>
                <Col md={8}>
                  <div className="inline-grid">
                    {/* <button className="btn btn-warning w-25" onClick={resetSpeed}>
                      Test
                    </button> */}
                    <div className="mt-2 d-flex justify-content-between">
                      <div className="progress-height mt-2 me-4">
                        <Progress color={pClass} value={percentage} />{" "}
                      </div>
                      <div>
                        {includes(arr, exerciseType.PRONUNCIATION_TASK) ? (
                          <i>
                            Your speed is
                              {downloadingSpeed ? (
                                ` ${downloadingSpeed?.mbps} mb `
                              ) : (
                                ' --- mb '
                              )}
                              per second. Required speed is 3 mb per second.
                          </i>
                        ):(
                          <i>
                            Your speed is
                            {downloadingSpeed ? (
                              ` ${downloadingSpeed?.mbps} mb `
                            ) : (
                              ' --- mb '
                            )}
                            per second. Required speed is 1 mb per second.
                          </i>
                        )}
                      </div>
                    </div>
                  </div>
                </Col>
              </>
          ):(
            <>
              <Col md={4}>Click test to check your internet speed:</Col>
              <Col md={8}>
                <div className="inline-grid">
                  <button className="btn btn-warning w-25" onClick={resetSpeed}>
                    Test
                  </button>
                  <div className="mt-2 d-flex justify-content-between">
                    <div className="progress-height mt-2 me-4">
                      <Progress color={pClass} value={percentage} />{" "}
                    </div>
                    <div>
                      <i>
                      Your Speed
                        {downloadingSpeed ? (
                          ` ${downloadingSpeed?.mbps} mbps`
                        ) : (
                          ' --- mbps'
                        )}
                        . Required 3MB
                      </i>
                    </div>
                  </div>
                </div>
              </Col>
            </>
          )
          }


    </Row>
  );
};
